import { FC } from "react";

interface IChangeLine {
  // "Çmimi një drejtim: 100 → 69", or a sentence without a field ("10 data u ndalën").
  line: string;
  className?: string;
  // In a table cell: the value it had before gives way first, so the value it has now stays readable.
  compact?: boolean;
}

// One changed field: its name and the value it ended up with in bold, the value it had before in grey,
// so a glance lands on what the field is and what it is now.
const ChangeLine: FC<IChangeLine> = ({ line, className = "", compact = false }) => {
  const separator = line.indexOf(": ");
  if (separator === -1) return <span className={`block truncate ${className}`}>{line}</span>;

  const label = line.slice(0, separator + 1);
  const values = line.slice(separator + 2);
  const arrow = values.indexOf(" → ");
  const before = arrow === -1 ? "" : values.slice(0, arrow);
  const after = arrow === -1 ? values : values.slice(arrow + 3);
  const oldValue = compact ? "inline-block max-w-[8rem] truncate align-bottom" : "";

  return (
    <span className={`block ${compact ? "flex items-baseline gap-1 overflow-hidden" : ""} ${className}`}>
      <span className="font-bold whitespace-nowrap">{label}</span>
      {before && (
        <>
          <span className={`text-gray-500 ${oldValue}`} title={before}>
            {before}
          </span>
          <span className="text-gray-400">→</span>
        </>
      )}
      <span className="font-bold whitespace-nowrap">{after}</span>
    </span>
  );
};

export default ChangeLine;
